/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deposit_Error_Amount_Must_Be_PositiveInputs */

const en_deposit_error_amount_must_be_positive = /** @type {(inputs: Deposit_Error_Amount_Must_Be_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter an amount greater than zero.`)
};

const de_deposit_error_amount_must_be_positive = /** @type {(inputs: Deposit_Error_Amount_Must_Be_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie einen Betrag größer als null ein.`)
};

const pt_br2_deposit_error_amount_must_be_positive = /** @type {(inputs: Deposit_Error_Amount_Must_Be_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite um valor maior que zero.`)
};

const tr_deposit_error_amount_must_be_positive = /** @type {(inputs: Deposit_Error_Amount_Must_Be_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sıfırdan büyük bir tutar girin.`)
};

const zh_cn2_deposit_error_amount_must_be_positive = /** @type {(inputs: Deposit_Error_Amount_Must_Be_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入大于零的金额。`)
};

const zh_hk2_deposit_error_amount_must_be_positive = /** @type {(inputs: Deposit_Error_Amount_Must_Be_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請輸入大於零的金額。`)
};

const ko_kr2_deposit_error_amount_must_be_positive = /** @type {(inputs: Deposit_Error_Amount_Must_Be_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0보다 큰 금액을 입력하세요.`)
};

const ru_ru2_deposit_error_amount_must_be_positive = /** @type {(inputs: Deposit_Error_Amount_Must_Be_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите сумму больше нуля.`)
};

const es_419_deposit_error_amount_must_be_positive = /** @type {(inputs: Deposit_Error_Amount_Must_Be_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa un monto mayor que cero.`)
};

/**
* | output |
* | --- |
* | "Enter an amount greater than zero." |
*
* @param {Deposit_Error_Amount_Must_Be_PositiveInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const deposit_error_amount_must_be_positive = /** @type {((inputs?: Deposit_Error_Amount_Must_Be_PositiveInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deposit_Error_Amount_Must_Be_PositiveInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deposit_error_amount_must_be_positive(inputs)
	if (locale === "de") return de_deposit_error_amount_must_be_positive(inputs)
	if (locale === "pt-BR") return pt_br2_deposit_error_amount_must_be_positive(inputs)
	if (locale === "tr") return tr_deposit_error_amount_must_be_positive(inputs)
	if (locale === "zh-CN") return zh_cn2_deposit_error_amount_must_be_positive(inputs)
	if (locale === "zh-HK") return zh_hk2_deposit_error_amount_must_be_positive(inputs)
	if (locale === "ko-KR") return ko_kr2_deposit_error_amount_must_be_positive(inputs)
	if (locale === "ru-RU") return ru_ru2_deposit_error_amount_must_be_positive(inputs)
	return es_419_deposit_error_amount_must_be_positive(inputs)
});